import { ICurrency } from '../../../models/Currency'
import { IStore } from '../../index'

export function getCurrency(state: IStore): ICurrency[] {
  return state.currency.currency
}
